import { forwardRef, memo } from "react";
import PropTypes from "prop-types";
import { FiLogOut, FiSettings } from "react-icons/fi";
import logo from "/images/logo.svg";

const Navbar = forwardRef(
  ({ isAuthenticated, handleLogout, setShowProfileOverlay }, ref) => {
    return (
      <nav
        ref={ref}
        className="w-full h-16 z-50 bg-black flex items-center justify-between px-4"
        id="safePad"
        aria-label="Main navigation"
      >
        <div className="flex items-center">
          <img src={logo} alt="Hybrid Energy Rock" className="h-12 w-auto" />
          <span className="hidden md:inline-block text-xl font-semibold text-transparent bg-clip-text bg-linear-to-r from-[#e1393e] via-[#fd6e4c] to-[#ffd450]">
            Hybrid Energy Rock
          </span>
        </div>
        <div className="absolute left-1/2 transform -translate-x-1/2">
          <span className="text-xl font-semibold text-white">Admin Panel</span>
        </div>
        {isAuthenticated && (
          <div className="flex items-center gap-4">
            <button
              onClick={() => setShowProfileOverlay(true)}
              className="text-gray-400 hover:text-gray-200 transition"
              aria-label="Settings"
            >
              <FiSettings size={24} />
            </button>
            <button
              onClick={handleLogout}
              className="text-red-500 hover:text-red-300 transition"
              aria-label="Logout"
            >
              <FiLogOut size={24} />
            </button>
          </div>
        )}
      </nav>
    );
  }
);

Navbar.displayName = "Navbar";

Navbar.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  handleLogout: PropTypes.func.isRequired,
  setShowProfileOverlay: PropTypes.func.isRequired,
};

export default memo(Navbar);
